// extracted by mini-css-extract-plugin
export default {"editIcon":"ChallengeRowMolecule_editIcon__Gnaxe","deleteIcon":"ChallengeRowMolecule_deleteIcon__3IYts"};